import * as yup from 'yup';

const schema = yup.object().shape({
  nome: yup.string().required('Nome completo deve ser preenchido'),
  telefone: yup.string().required('O telefone deve ser preenchido'),
});

export default schema;
